module.exports = __webpack_public_path__ + "img/tutorial_BG_auto2.6e7cc81d.jpg";